"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComplexity = getComplexity;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the complexity of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns ComputedData
 */
function getComplexity(data) {
    const complexity = (0, getNumberProperties_1.getNumberProperties)(data, 'Complexity');
    return complexity;
}
//# sourceMappingURL=getComplexity.js.map